module.exports = __webpack_public_path__ + "static/insta4-3d6b8cf07d1a2a10cd0eb09f9ef56015.png";